<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sec_chap">List of Archival Maps</h2>
<p class="hanging">Map 1A: The Western Front’s Situation at 2000 hours on 5 July 1941. The Western Front’s Left Wing</p>
<p class="hanging">Map 1B: The Western Front’s Situation at 2000 hours on 5 July 1941. The Western Front’s Right Wing</p>
<p class="hanging">Map 2: The Correlation of Forces in the Western Front’s sector on 12 July 1941</p>
<p class="hanging">Map 3A: Situation on 20 July 1941. The Western Front’s Left-Wing</p>
<p class="hanging">Map 3B: Situation on 20 July 1941. The Western Front’s Right Wing.</p>
<p class="hanging">Map 3C: The Dispositions of the 19th and 4th Reserve Armies on 21 July 1941</p>
<p class="hanging">Map 5: The Basing of the Western Front’s Air Forces (VVS) on 1 August 1941</p>
<p class="hanging">Map 6A: Situation from 6 through 8 August 1941. The Western Front’s Left Wing</p>
<p class="hanging">Map 6B: Situation from 6 through 8 August 1941. The Western Front’s Center.</p>
<p class="hanging">Map 6C: Situation from 6 through 8 August 1941. The Western Front’s Right Wing.</p>
<p class="hanging">Map 7: The Western Front’s Situation and Force Missions according to Combat Order No. 01/op of 15 August 1941</p>
<p class="hanging">Map 8: 20th Army’s Combat Operations from 6 through 8 August 1941</p>
<p class="hanging">Map 9: The Western Front’s Combat Operations from 24 August through 10 September 1941</p>
<p class="hanging">Map 10A: Situation on 4 September 1941. The Briansk Front’s Left Wing.</p>
<p class="hanging">Map 10B: Situation on 4 September 1941. The Briansk Front’s Right Wing.</p>
<p class="hanging">Map 11: The Southwestern Front’s Situation Late on 9 September 1941 600</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_List_Maps.vue?64b522b4